'use client';

import { useEffect } from 'react';
import Script from 'next/script';
import pushToDataLayer from 'lib/analytics/pushToDataLayer';
import useIsHydrated from 'hooks/use-is-hydrated';
import { usePathname } from 'next/navigation';

const containerId = 'GTM-KBJJBHH';
const noScriptURL = `https://www.googletagmanager.com/ns.html?id=${containerId}`;
const snippet = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${containerId}');`;

//This "has" to get sent before all other events,
//or else Scandiweb says none of the other events will get "routed" to the "right channels":
const pushGeneralEvent = (relativePath) => {
	if (!relativePath) {
		return;
	}

	const firstPathSegment = relativePath
		.split('/')
		.filter((segment) => segment.length)[0];
	// https://docs.google.com/spreadsheets/d/1c4Jtp357yYMZ6-PHhpapPKW7LMrqYDtvrrFV7aulKXA/edit#gid=2125107399
	pushToDataLayer({
		event: 'general',
		current_environment: 'metmuseum.org',
		content_group: firstPathSegment || 'homepage', // obviously "/".split("/")[0] is undefined
	});
};

const GTM = () => {
	const pathname = usePathname();
	const isHydrated = useIsHydrated();

	useEffect(() => {
		const url = pathname;
		pushGeneralEvent(url);
	}, [pathname]);

	if (!isHydrated) {
		return null;
	}

	return (
		<>
			<noscript>
				<iframe
					src={noScriptURL}
					height="0"
					width="0"
					style={{ display: 'none', visibility: 'hidden' }}
				></iframe>
			</noscript>
			<Script id="google-tag-manager" strategy="afterInteractive">
				{snippet}
			</Script>
		</>
	);
};

export default GTM;
